import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface SuccessPopupProps {
  open: boolean;
  onClose: () => void;
}

const SuccessPopup = ({ open, onClose }: SuccessPopupProps) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: { borderRadius: 3, padding: 2, maxWidth: 400, width: '100%' }
      }}
    >
      <DialogContent>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          textAlign="center"
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 60, color: '#4caf50', mb: 2 }} />
          
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Enquiry Sent!
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Thank you for reaching out. Our team will contact you shortly.
          </Typography>

          <Button 
            fullWidth 
            variant="contained" 
            onClick={onClose}
            sx={{ 
              backgroundColor: '#FFB733', 
              color: '#000',
              fontWeight: 'bold',
              '&:hover': { backgroundColor: '#e7c382' }
            }}
          >
            Okay, Got it
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessPopup;